var App = App || {};

App.Parallax = (function ($) {
    "use strict";

    function init() {
        //midground parallax (move up when scrolling down)
        $(".component .midground-plus").MidgroundParallax({ downDivisor: -3 });
        $(".img-midground-parallax.arrows").MidgroundParallax({ downDivisor: -8, rightDivisor: 8 });
        $(".component-rates-band .rates-band-background").MidgroundParallax({ downDivisor: -8, rightDivisor: 8 });

        //image parallax (standard ZagParallax functionality)
        $(".component-homepage-banner .homepage-banner-image-wrapper.desktop").ZagParallax({ divisor: 5 });
        $(".component-homepage-banner .homepage-banner-image-wrapper.mobile").ZagParallax({ divisor: 15 });
        $(".component-landing-masthead .image-wrapper").ZagParallax({ divisor: 8 });
        $(".component-cross-promo-band .image-content-wrapper").ZagParallax({ divisor: 7 });
        $(".component-rates-band .image-content-wrapper").ZagParallax({ divisor: 10 });
        $(".page-masthead.category .page-masthead-image, .page-masthead-image.event").ZagParallax({ divisor: 7 });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Parallax.init();
});